import { ManagementFormResponse, FormForwardUserStatus, FormForwardType } from '@business/entities/managementForms';
import { Endpoint } from '../endpoint';
import { UserId } from '@business/entities/account';
import { FormId } from '@business/entities/managementFormTemplate';
import { FolderId } from '@business/entities/library';

export function createForm(name: string, folderId: FolderId, form: FormId) {
  return Endpoint.post<ManagementFormResponse>(`@makh/management-form`, { data: { name, folderId, form } });
}

export function fetchForms() {
  return Endpoint.get<ManagementFormResponse[]>(`@makh/management-form`);
}

export function fetchForm(id: FormId) {
  return Endpoint.get<ManagementFormResponse>(`@makh/management-form/form/${id}`);
}

export function saveFormValues(id: string, values: string, status: FormForwardUserStatus) {
  return Endpoint.post<ManagementFormResponse>(`@makh/management-form/save-values/${id}`, { data: { values, status } });
}

export function forwardForm(id: FormId, users: UserId[], comment?: string, type?: FormForwardType) {
  return Endpoint.post<ManagementFormResponse>(`@makh/management-form/forward`, { data: { id, users, comment, type } });
}

export function updateForwardedStatus(id: string, status: FormForwardUserStatus, finalize?: boolean) {
  return Endpoint.patch<ManagementFormResponse>(`@makh/management-form/forwarded-status/${id}`, { data: { status, finalize } });
}
